import React, { useEffect, useState } from "react";
// import './index.css';
import {
  BellOutlined,
  BookOutlined,
  CalendarOutlined,
  FileTextOutlined,
  HomeOutlined,
  LeftCircleOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SwapLeftOutlined,
  TrophyOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { Badge, Button, Drawer, Layout, Menu, theme, Typography } from "antd";
import Assignments from "./Assignments";
import Home from "./DashboardHome";
import Notes from "./Notes";
import Achievements from "./Achievments";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Courses from "./Courses";
import Sessions from "./Sessions";
import NotificationList from "../../components/pageComponents/NotificationList";
import ProfileMenu from "../../components/pageComponents/ProfileMenu";
import ProfilePage from "../ProfilePage";
import CourseView from "./Courses/CourseView";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux Store/Slices/auth";

import BrandImage from '../../assets/images/brand.png'
import DarkModeToggle from "../../components/DarkModeToggle";

const { Header, Sider, Content } = Layout;

const Dashboard = () => {
  const [state, setState] = useState("course-view");
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  // useEffect(() => {
  //     let hash = window.location.hash;
  //     if (!hash) {
  //         location.hash.replace('#', 'home')
  //         return;
  //     }
  //     const page = window.location.hash.slice(1, hash.length) || "home";
  //     console.log({ page, hash })
  //     setState(page)
  // }, [])
  const [open, setOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const [menuList] = useState([
    {
      key: "/dashboard/",
      label: "Home",
      icon: <HomeOutlined />,
    },
    {
      key: "assignment",
      label: "Assignments",
      icon: <FileTextOutlined />,
      disabled: true,
    },
    {
      key: "notes",
      label: "Notes",
      icon: <BookOutlined />,
      disabled: true,

    },
    {
      key: "sessions",
      label: "Sessions",
      icon: <CalendarOutlined />,
      disabled: true
    },
    {
      key: "courses",
      label: "Courses",
      icon: <BookOutlined />,
    },
    {
      key: "achievements",
      label: "Achievements",
      icon: <TrophyOutlined />,
      disabled: true
    },
  ]);

  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();


  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Layout className="h-screen">
      {collapsed && <Sider
        trigger={null}
        collapsible
        collapsed={!false}
        className="h-screen"
        theme="light"
      >
        <div className="h-16 mb-5 w-full grid place-content-center bg-gray-900">
          <img src={BrandImage} alt="" className="h-16 cursor-pointer" onClick={() => navigate("/dashboard")} />
        </div>
        {<Menu
          mode="inline"
          defaultSelectedKeys={"/dashboard/"}
          items={menuList}
          onClick={(e) => {
            if (e.disabled) {
              return; // Prevent navigation if the menu item is disabled
            }

            const { key } = e;
            console.log(`Key: ${key}`);
            // setState(key);
            navigate(`${key}`);
          }}
        />}
      </Sider>}
      <Layout>
        <Header
          style={{ padding: 0, background: colorBgContainer }}
          className="flex gap-4 items-center"
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            className="md:block"
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
          <div className="flex gap-0 mr-auto items-center">

            <Button
              type="text"
              icon={<LeftCircleOutlined />}
              onClick={() => navigate(-1)}
              className="md:block"
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />
            <Typography.Title level={5} className="relative top-1 mr-auto pl-4">
              Pronttera Labs
            </Typography.Title>
          </div>

          {/* <Badge count={5} className='ml-auto'>
            <Button variant='text' onClick={showDrawer} shape="circle">
              <BellOutlined />
            </Button>
          </Badge> */}
          {/* <DarkModeToggle /> */}
          <ProfileMenu userFullName={user?.name} userName={user?.email} list={[
            {
              icon: <UserOutlined />,
              label: "See Profile",
              onClick: () => { setShowProfile(true) }
            },
            {
              icon: <LogoutOutlined />,
              label: "Logout",
              onClick: () => {
                navigate("/")
                dispatch(logout())
              }
            }
          ]} />
        </Header>
        <Content
          style={{
            // margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            overflow: "auto",
          }}
          className="m-0 md:m-5"
        >
          <section className="mx-auto max-w-[1400px]">
            {/* {switchOfPage(state)} */}
            <Outlet />
          </section>
        </Content>
      </Layout>
      <Drawer title="Notifications" onClose={onClose} open={open}>
        <NotificationList />
      </Drawer>
      <Drawer title="Profile" onClose={() => setShowProfile(false)} open={showProfile}>
        <ProfilePage />
      </Drawer>
    </Layout>
  );
};

export default Dashboard;

const switchOfPage = (page) => {
  switch (page) {
    case "home":
    // return <Home />;
    case "assignment":
      return <Assignments />;
    case "notes":
      return <Notes />;
    case "courses":
      return <Courses />;
    case "achievments":
      return <Achievements />;
    case "sessions":
      return <Sessions />;
    case "course-view":
      return <CourseView />;
    default:
      return <Home />;
  }
};
